module.exports = __webpack_public_path__ + "static/media/JULD.8c1b70a5.png";